import { render } from "./discussion.vue?vue&type=template&id=f0e9ad7e&scoped=true"
import script from "./discussion.vue?vue&type=script&lang=js"
export * from "./discussion.vue?vue&type=script&lang=js"

import "./discussion.vue?vue&type=style&index=0&id=f0e9ad7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e9ad7e"]])

export default __exports__